import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import SocialBtns from "../../SubComponents/SocialBtns/SocialBtns"
class SignupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  // static getDerivedStateFromProps(props, state) {
  //   if (props.state.isSignupModal == state.open) {
  //     return {
  //       homeData: {},
  //       open: props.state.isSignupModal
  //     };
  //   }
  //   return null;
  // }

  signup = () => {
    this.props.signUpByEmail();
  };

  closeModal = () => {
    let modalId = (this.props.state.isOtpModal) ? 'otpModal' : 'signUpModal'
    this.props.closeModal(modalId);
  };

  render() {

    const formInputstyles = {
      position: 'absolute',
      left:0,
      top:0,
      transform: 'scale(0.8)',
      transformOrigin: 'left top',
      color: '#999',
      transition: 'all 0.3s',
      pointerEvents: 'none',
    }
        
    return (
      <Modal isOpen={this.props.state.isOpenModal} aria-labelledby="ModalHeader">
        <ModalBody>
          <button
            type="button"
            className="close btn-close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={this.closeModal}
          >
            <span aria-hidden="true">×</span>
          </button>
          <div className="loginModalContainer">
            <div className="leftSide">
              <div className="inner">
                <div className="inner-header">
                  <img alt="" src="images/logo/logo.png" className="logo" />
                </div>
                <div className="inner-body">
                  {/* Signup Container Start*/}
                  <div
                    className="signupContainer"
                    style={this.props.state.isSignupModal ? {} : { display: "none" }}
                  >
                    <p className="subTitle">
                    Welcome, Please Register to your account.
                    </p>
                    <div className="socialBtns ">
                      <SocialBtns signupLoginBySocial={this.props.signupLoginBySocial}/>
                    </div>
                    <div className="dividerDiv">
                      <span>Or</span>
                    </div>
                    <div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="hasPlaceholder">
                              <input
                                type="text"
                                name="firstname"
                                onChange={this.props.onChnageHandler}
                                value={this.props.state.firstname}
                              />
                              <span><span style={formInputstyles}>Firstname</span></span>
                              <span className="errorMsg">{this.props.state.signupFormErrors.firstname}</span>
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="hasPlaceholder">
                              <input
                                type="text"
                                name="lastname"
                                onChange={this.props.onChnageHandler}
                                value={this.props.state.lastname}
                              />
                              <span><span style={formInputstyles}>Lastname</span></span>
                              <span className="errorMsg">{this.props.state.signupFormErrors.lastname}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="hasPlaceholder">
                          <input
                            type="text"
                            name="email"
                            onChange={this.props.onChnageHandler}
                            value={this.props.state.email}
                          />
                          <span><span style={formInputstyles}>E-mail Address</span></span>
                          <span className="errorMsg">{this.props.state.signupFormErrors.email}</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <label className="hasPlaceholder">
                          <input
                            type="password"
                            name="password"
                            onChange={this.props.onChnageHandler}
                            //value={this.props.state.password}
                          />
                          <span> <span style={formInputstyles}>Password</span></span>
                          <span className="errorMsg">{this.props.state.signupFormErrors.password}</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <label className="hasPlaceholder">
                          <input
                            type="password"
                            name="conf_password"
                            onChange={this.props.onChnageHandler}
                          />
                          <span><span style={formInputstyles}>Confirm Password</span></span>
                          <span className="errorMsg">{this.props.state.signupFormErrors.conf_password}</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <Link
                          to="#"
                          className="btn btn-danger"
                          id="forOtp"
                          onClick={this.signup}
                        >
                          Signup
                        </Link>
                      </div>
                      <div style={{ marginTop: "35px", fontSize: "12px" }}>
                        <span style={{ color: "#999" }}>Already Account? </span>
                        <Link to="#" className="link toLoginBtn" onClick={this.props.openModal.bind(this,'loginModal')}> Click Here </Link>
                      </div>
                    </div>
                  </div>
                 <div className="otpContainer2" style={this.props.state.isOtpModal ? {} : { display: "none" }} >
                    <p className="subTitle">
                      Please type the verification code send to
                      {" "}{this.props.state.email}
                    </p>
                    <div>
                      <div className="form-group">
                        <label className="hasPlaceholder">
                          <input type="text" name="otp_code" value={this.props.otp_code} onChange={this.props.onChnageOtp} maxLength="6" pattern="\d{6}"/>
                          <span>
                            <span style={formInputstyles}>OTP Code</span>
                          </span>
                        </label>
                      </div>
                      <div className="form-group">
                        <Link to="#" className="btn btn-danger" onClick={this.props.otpVerifyHandler}> Done </Link>
                      </div>

                      <div style={{ marginTop: "35px", fontSize: "12px" }}>
                        <span style={{ color: "rgb(94, 91, 91)" , fontSize: "14px" }}> {(this.props.state.timeObj!==undefined) && this.props.state.timeObj.m+':'+this.props.state.timeObj.s}</span>
                        {(this.props.state.resendOtpBtn) 
                          ? <Link to="#" className="link toLoginBtn" onClick={this.props.otpResendHandler}> Resend OTP </Link> 
                          : <Link to="#" className="toLoginBtn" style={{ color: "#999" }}> Resend OTP </Link> }
                      </div>

                      {/* <div style={{ marginTop: "35px", fontSize: "12px" }}>
                        <span style={{ color: "#999" }}>Already Account? </span>
                        <Link to="#" className="link toLoginBtn" onClick={this.props.openModal.bind(this,'loginModal')}> Click Here </Link>
                      </div> */}
                    </div>
                  </div>
                  <div
                    className="forgotPasswordContainer"
                    style={{ display: "none" }}
                  >
                    <p className="subTitle">Forgot Password?</p>
                    <span style={{ position: "relative", top: "-25px" }}>
                      We Just need your registered Email ID to send your
                      password reset instructions
                    </span>
                    <div>
                      <div className="form-group">
                        <label className="hasPlaceholder">
                          <input type="text" placeholder=" " />
                          <span>
                            <span style={formInputstyles}>Email Address</span>
                          </span>
                        </label>
                      </div>
                      <div className="form-group">
                        <Link to="#" className="btn btn-danger" id="sendMailBtn">
                          Send
                        </Link>
                      </div>
                      <div style={{ marginTop: "35px", fontSize: "12px" }}>
                        <Link to="#" className="link toLoginBtn">
                          Back to Login
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    className="setPasswordContainer"
                    style={{ display: "none" }}
                  >
                    <p className="subTitle">Reset Your Password</p>
                    <div>
                      <div className="form-group">
                        <label className="hasPlaceholder">
                          <input
                            type="password"
                            placeholder=" "
                            onChange={this.onChnageHandler}
                          />
                          <span>
                            <span>Password</span>
                          </span>
                        </label>
                      </div>
                      <div className="form-group">
                        <label className="hasPlaceholder">
                          <input type="password" placeholder=" " />
                          <span>
                            <span>Confirm Password</span>
                          </span>
                        </label>
                      </div>
                      <div className="form-group">
                        <Link
                          to="#"
                          className="btn btn-danger"
                          id="passwordSaveBtn"
                        >
                          Save
                        </Link>
                      </div>
                      <div style={{ marginTop: "35px", fontSize: "12px" }}>
                        <Link to="#" className="link toLoginBtn">
                          Back to Login
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* Signup Container End*/}
                  <div style={{ marginTop: "35px" }}>
                    <span>
                    By signing up you agree to Comrate's{" "}
                      <Link to="/term-conditions" className="link">
                       Terms and conditions
                      </Link>{" "}
                      &amp;{" "}
                      <Link to="/term-conditions" className="link">
                        Privacy Policy
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="rightSide">
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    "\n                                    css-doodle {\n                                        --color: @p(#2eabee, #f66, #A8DADC, #457B9D, #1D3557);\n                                        /*--color: @p(#E63946, #F1FAEE, #A8DADC, #457B9D, #1D3557);*/\n                                        --position: @r(0%, 100%) @r(0%, 100%);\n\n                                        --pat-1: (\n                                            linear-gradient(var(--color), @lp())\n                                            var(--position) / @r(1px) @r(15%)\n                                            no-repeat\n                                            );\n\n                                        --pat-2: (\n                                            linear-gradient(\n                                            @pick(\n                                            -180deg, -135deg, -90deg, -45deg,\n                                            0deg, 45deg, 90deg, 135deg, 180deg \n                                            ),\n                                            var(--color) 50%, transparent 0)\n                                            var(--position) / @r(3%) @lr()\n                                            no-repeat\n                                            );\n\n                                        --pat-3: (\n                                            linear-gradient(var(--color), @lp())\n                                            var(--position) / @r(15%) 1px\n                                            no-repeat\n                                            );\n\n                                        --pat-4: (\n                                            radial-gradient(var(--color), @lp())\n                                            var(--position) / @r(5%) @lr()\n                                            no-repeat\n                                            );\n\n                                        --pat-5: (\n                                            radial-gradient(var(--color) 50%, transparent 0)\n                                            var(--position) / @r(5%) @lr()\n                                            no-repeat\n                                            );\n\n                                        --pat-6: (\n                                            conic-gradient(\n                                            from calc(145deg + @ri(4) * 90deg), \n                                            var(--color) 0,\n                                            @lp() 20%,\n                                            transparent 20%,\n                                            transparent 50%\n                                            )\n                                            var(--position) / @r(5%) @lr()\n                                            no-repeat\n                                            );\n\n                                        --pat-7: (\n                                            linear-gradient(\n                                            @p(45deg, -45deg),\n                                            transparent 0,\n                                            transparent calc(50% - .2px),\n                                            var(--color) calc(50% - .5px),\n                                            @lp() calc(50% + .5px),\n                                            transparent calc(50% + .2px)\n                                            )\n                                            var(--position) / @r(5%) @lr()\n                                            no-repeat\n                                            );\n\n                                        --rule: (\n                                            :doodle {\n                                            @grid: 1 / 100vmax;\n                                            position: absolute;\n                                        }\n                                        background-blend-mode: color-burn;\n                                        background:\n                                            @m(80, var(--pat-1)),\n                                            @m(80, var(--pat-2)),\n                                            @m(80, var(--pat-3)),\n                                            @m(80, var(--pat-4)),\n                                            @m(80, var(--pat-5)),\n                                            @m(80, var(--pat-6)),\n                                            @m(80, var(--pat-7));\n                                        );\n                                    }\n                                "
                }}
              />
              <css-doodle use="var(--rule)" />
            </div>
          </div>
        </ModalBody>
      </Modal>
    );

  }
}

export default SignupModal;